import { Stack, Text, Textarea } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface RejectOfferModalProps {
  opened: boolean;
  offerLabel: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const RejectOfferModal = ({
  opened,
  offerLabel,
  onClose,
  onConfirm,
  loading,
  isPaused
}: RejectOfferModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={handleClose}
      onConfirm={() => onConfirm(reason.trim())}
      loading={loading}
      isPaused={isPaused}
      confirmDisabled={!reason.trim()}
      danger
      title={t('offerDetail.rejectModalTitle')}
      message={t('offerDetail.rejectModalMessage', { number: offerLabel })}
      confirmLabel={t('offerDetail.rejectModalConfirm')}
    >
      <Stack gap={6}>
        <Text fz={11} fw={600} style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4 }}>
          {t('offerDetail.rejectModalReasonLabel')}
        </Text>
        <Textarea
          value={reason}
          onChange={(event) => setReason(event.currentTarget.value)}
          placeholder={t('offerDetail.rejectModalReasonPlaceholder')}
          autosize
          minRows={4}
          styles={{
            input: {
              backgroundColor: 'var(--color-bg-surface-2)',
              borderColor: 'var(--color-border-default)',
              color: 'var(--color-text-primary)'
            }
          }}
        />
      </Stack>
    </ConfirmActionModal>
  );
};
